import { render, staticRenderFns } from "./userHome.vue?vue&type=template&id=6f96cfb0&scoped=true&"
import script from "./userHome.vue?vue&type=script&lang=js&"
export * from "./userHome.vue?vue&type=script&lang=js&"
import style0 from "./userHome.vue?vue&type=style&index=0&id=6f96cfb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96cfb0",
  null
  
)

export default component.exports